import { StoreModel } from '../../models/Index';
import { AxiosRequestConfig, AxiosResponse, AxiosInstance } from 'axios';
import LoaderModel from 'models/shared/LoaderModel';

export function UseLoaderInterceptor(instance: AxiosInstance, Store: StoreModel) {
    const { loader } = Store;
    instance.interceptors.request.use((request) => showLoaderOnRequest(request, loader));
    instance.interceptors.response.use(
        (response) => hideLoaderOnResponse(response, loader),
        (response) => hideLoaderOnError(response, loader)
    );

    return instance;
}

function showLoaderOnRequest(request: AxiosRequestConfig, loader: LoaderModel) {
    if (!(request as any).disableLoader) {
        loader.show();
    }

    return request;
}

function hideLoaderOnResponse(response: AxiosResponse<any>, loader: LoaderModel) {
    if (!(response.config as any).disableLoader) {
        loader.hide();
    }

    return response;
}

function hideLoaderOnError(error: any, loader: LoaderModel) {
    loader.hide();
    return Promise.reject(error);
}
